import { getSharedLang } from './base-i18n';

/**
 * 앱 다운로드 문구 (2026-09-14 · 설정 › 다운로드 · /app/download/:platform).
 * ★ 설정 사전(`settings-i18n`)을 늘리지 않고 따로 둔다 — 화면 둘이 같이 쓴다.
 */
const MESSAGES = {
  'dl.heading': { ko: '앱 다운로드', en: 'Download the app', ja: 'アプリのダウンロード' },
  'dl.desc': {
    ko: '사내 배포 — 회사 서버에서 직접 받습니다. 앱 마켓에는 올라가 있지 않습니다.',
    en: 'Internal distribution — download directly from your company server. The app is not on app stores.',
    ja: '社内配布 — 会社のサーバーから直接ダウンロードします。アプリストアにはありません。',
  },
  'dl.android': { ko: 'Android', en: 'Android', ja: 'Android' },
  'dl.ios': { ko: 'iPhone · iPad', en: 'iPhone · iPad', ja: 'iPhone · iPad' },
  'dl.pc': { ko: 'Windows · macOS', en: 'Windows · macOS', ja: 'Windows · macOS' },
  'dl.pc_desc': { ko: '데스크톱 설치본', en: 'Desktop installer', ja: 'デスクトップ版インストーラ' },
  'dl.ios_desc': {
    ko: '배포 인증서가 정해지면 같은 방식(QR · 로그인)으로 열립니다',
    en: 'Opens the same way (QR · sign-in) once the distribution certificate is set',
    ja: '配布証明書が決まり次第、同じ方法（QR・ログイン）で開きます',
  },
  'dl.pending': { ko: '준비 중', en: 'Coming soon', ja: '準備中' },
  'dl.latest': { ko: '최신', en: 'Latest', ja: '最新' },
  'dl.loading': { ko: '불러오는 중…', en: 'Loading…', ja: '読み込み中…' },
  'dl.error': { ko: '앱 정보를 불러오지 못했습니다.', en: 'Could not load app information.', ja: 'アプリ情報を読み込めませんでした。' },
  'dl.retry': { ko: '다시 시도', en: 'Retry', ja: '再試行' },
  'dl.empty_title': { ko: '아직 게시된 버전이 없습니다', en: 'No published version yet', ja: '公開されたバージョンはまだありません' },
  'dl.empty_desc': {
    ko: '시스템 관리자가 앱을 등록하면 이 자리에 버전과 QR 이 나타납니다.',
    en: 'The version and QR code will appear here once a system administrator publishes the app.',
    ja: 'システム管理者がアプリを登録すると、ここにバージョンとQRが表示されます。',
  },
  'dl.mdm_title': { ko: 'MDM 으로 배포됩니다', en: 'Distributed via MDM', ja: 'MDMで配布されます' },
  'dl.mdm_desc': {
    ko: '이 회사는 기기 관리(MDM)로 앱을 설치 · 업데이트합니다. 설치가 필요하면 관리자에게 문의하세요.',
    en: 'Your company installs and updates the app through device management (MDM). Contact your administrator.',
    ja: 'この会社はデバイス管理（MDM）でアプリをインストール・更新します。管理者にお問い合わせください。',
  },
  'dl.fact_version': { ko: '버전', en: 'Version', ja: 'バージョン' },
  'dl.fact_build': { ko: '빌드', en: 'Build', ja: 'ビルド' },
  'dl.fact_published': { ko: '게시일', en: 'Published', ja: '公開日' },
  'dl.fact_size': { ko: '크기', en: 'Size', ja: 'サイズ' },
  'dl.fact_min': { ko: '최소 지원', en: 'Minimum supported', ja: '最小サポート' },
  'dl.fact_min_value': { ko: '{code} 이상', en: '{code} or later', ja: '{code} 以上' },
  'dl.sig': { ko: '서명 지문', en: 'Signing fingerprint', ja: '署名フィンガープリント' },
  'dl.sig_note': { ko: '회사가 등록한 앱인지 확인할 때 봅니다', en: 'Use this to confirm the app is the one your company registered', ja: '会社が登録したアプリか確認するときに使います' },
  'dl.notes': { ko: '이번 버전에서 바뀐 것', en: 'What’s new', ja: 'このバージョンの変更点' },
  'dl.get_pc': { ko: '이 PC 로 받기 (APK)', en: 'Download to this PC (APK)', ja: 'このPCにダウンロード（APK）' },
  'dl.copy': { ko: '받기 주소 복사', en: 'Copy download link', ja: 'ダウンロードリンクをコピー' },
  'dl.copied': { ko: '주소를 복사했습니다', en: 'Link copied', ja: 'リンクをコピーしました' },
  'dl.copy_failed': { ko: '복사하지 못했습니다 — 주소를 직접 선택하세요', en: 'Could not copy — select the link manually', ja: 'コピーできませんでした — リンクを直接選択してください' },
  'dl.gone': { ko: '이 버전은 더 받을 수 없습니다 — 최신 버전을 다시 불러옵니다.', en: 'This version is no longer available — reloading the latest version.', ja: 'このバージョンは入手できなくなりました — 最新バージョンを再読み込みします。' },
  'dl.revoked': { ko: '이 버전은 회수됐습니다 — 최신 버전을 다시 불러옵니다.', en: 'This version was withdrawn — reloading the latest version.', ja: 'このバージョンは取り下げられました — 最新バージョンを再読み込みします。' },
  'dl.download_failed': { ko: '받기 주소를 만들지 못했습니다. 잠시 뒤 다시 시도하세요.', en: 'Could not create a download link. Try again shortly.', ja: 'ダウンロードリンクを作成できませんでした。しばらくして再試行してください。' },
  'dl.qr_title': { ko: '휴대폰으로 받기', en: 'Get it on your phone', ja: 'スマートフォンで受け取る' },
  'dl.qr_desc': { ko: '카메라로 찍으면 로그인한 뒤 받기 화면이 열립니다', en: 'Scan with your camera — the download page opens after you sign in', ja: 'カメラで読み取ると、ログイン後にダウンロード画面が開きます' },
  'dl.qr_alt': { ko: '{platform} 받기 화면으로 가는 QR', en: 'QR code to the {platform} download page', ja: '{platform} ダウンロード画面へのQR' },
  'dl.guide_title': { ko: '처음 설치할 때', en: 'First-time install', ja: '初めてインストールするとき' },
  'dl.guide_1_t': { ko: 'QR 찍기', en: 'Scan the QR', ja: 'QRを読み取る' },
  'dl.guide_1_d': { ko: '휴대폰 카메라로 QR 을 찍습니다', en: 'Scan the QR code with your phone camera', ja: 'スマートフォンのカメラでQRを読み取ります' },
  'dl.guide_2_t': { ko: '로그인', en: 'Sign in', ja: 'ログイン' },
  'dl.guide_2_d': { ko: '회사 계정으로 로그인하면 받기 화면으로 돌아옵니다', en: 'Sign in with your company account to return to the download page', ja: '会社アカウントでログインするとダウンロード画面に戻ります' },
  'dl.guide_3_t': { ko: '설치 허용', en: 'Allow installs', ja: 'インストールを許可' },
  'dl.guide_3_d': { ko: '「출처를 알 수 없는 앱」 설치를 받은 앱(브라우저)에 한 번만 허용합니다', en: 'Allow “install unknown apps” once for the app you downloaded with (browser)', ja: '「提供元不明のアプリ」のインストールを、ダウンロードしたアプリ（ブラウザ）に一度だけ許可します' },
  'dl.guide_4_t': { ko: '설치 · 업데이트', en: 'Install · update', ja: 'インストール・更新' },
  'dl.guide_4_d': { ko: '새 버전도 같은 방법으로 받아 덮어 설치합니다 — 데이터는 남습니다', en: 'Get new versions the same way and install over the old one — your data stays', ja: '新しいバージョンも同じ方法で上書きインストールします — データは残ります' },
  'dl.warn': {
    ko: '회사 서버에서만 받으세요. 다른 곳에서 받은 파일은 서명이 달라 설치되지 않거나 업데이트가 막힙니다.',
    en: 'Download only from your company server. Files from elsewhere have a different signature and won’t install or update.',
    ja: '会社のサーバーからのみダウンロードしてください。他で入手したファイルは署名が異なり、インストールや更新ができません。',
  },
  // /app/download/:platform
  'dl.page_title': { ko: 'AXI Works 받기', en: 'Get AXI Works', ja: 'AXI Works を入手' },
  'dl.page_download': { ko: '내려받기', en: 'Download', ja: 'ダウンロード' },
  'dl.page_how': { ko: '설치하는 법', en: 'How to install', ja: 'インストール方法' },
  'dl.page_step_1': { ko: '「내려받기」를 누릅니다', en: 'Tap “Download”', ja: '「ダウンロード」をタップします' },
  'dl.page_step_2': { ko: '「출처를 알 수 없는 앱」 허용 안내가 나오면 설정에서 이 브라우저를 허용합니다', en: 'If asked about “unknown apps”, allow this browser in Settings', ja: '「提供元不明のアプリ」の案内が出たら、設定でこのブラウザを許可します' },
  'dl.page_step_3': { ko: '받은 파일을 열어 설치합니다', en: 'Open the downloaded file to install', ja: 'ダウンロードしたファイルを開いてインストールします' },
  'dl.page_bad_platform': { ko: '지원하지 않는 기기입니다', en: 'This device is not supported', ja: 'サポートされていない端末です' },
  'dl.page_back': { ko: '처음 화면으로', en: 'Go to home', ja: 'ホームへ' },
} as const satisfies Record<string, { ko: string; en: string; ja: string }>;

export type AppDownloadI18nKey = keyof typeof MESSAGES;

export function tDl(key: AppDownloadI18nKey, params?: Record<string, string | number>): string {
  const m = MESSAGES[key];
  const lang = getSharedLang();
  const raw: string = (m as Record<string, string>)[lang] ?? m.ko;
  if (!params) return raw;
  return raw.replace(/\{(\w+)\}/g, (_, name: string) => (params[name] === undefined ? `{${name}}` : String(params[name])));
}
